import RemoteCall from "../util/RemoteCall";

const remoteCall = new RemoteCall("api/plt");


const logoutAsync = async () => {
    await remoteCall.invoke("logout");
};


export default {
    logoutAsync,
};
